import { render, staticRenderFns } from "./errDetail.vue?vue&type=template&id=bf25d326&scoped=true"
import script from "./errDetail.vue?vue&type=script&lang=js"
export * from "./errDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf25d326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf25d326')) {
      api.createRecord('bf25d326', component.options)
    } else {
      api.reload('bf25d326', component.options)
    }
    module.hot.accept("./errDetail.vue?vue&type=template&id=bf25d326&scoped=true", function () {
      api.rerender('bf25d326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/journal/errRecord/errDetail.vue"
export default component.exports